import { User, Camera, BadgeCheck, ShieldCheck, HardHat, Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { TEAM, COMBINED_CAPABILITY } from "../../data/siteData";

const ProfileCard = ({ member, idx }) => (
  <Reveal delay={idx * 0.1}>
    <div className="group card-dark rounded-2xl overflow-hidden h-full flex flex-col" data-testid={`team-card-${idx}`}>
      {/* Placeholder photo area */}
      <div className="relative aspect-[4/3] bg-gradient-to-br from-[#0d2747] to-[#081C3A] flex flex-col items-center justify-center overflow-hidden">
        <div className="absolute inset-0 hero-grid-overlay opacity-30" />
        <div className="relative w-20 h-20 rounded-full bg-[#00D4FF]/10 border border-[#00D4FF]/25 flex items-center justify-center mb-3">
          <User className="w-10 h-10 text-[#00D4FF]/70" />
          <span className="absolute -bottom-1 -right-1 text-xs font-bold text-[#04121f] bg-[#00D4FF] rounded-full w-8 h-8 flex items-center justify-center">
            {member.initials}
          </span>
        </div>
        <span className="relative inline-flex items-center gap-1.5 text-xs text-slate-400">
          <Camera className="w-3.5 h-3.5" /> Photo coming soon
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1 border-t border-white/5">
        <h3 className="text-xl font-bold text-white">{member.name}</h3>
        <p className="text-sm font-semibold text-[#00D4FF] mt-1.5 leading-snug">{member.role}</p>
        <div className="mt-4 pt-4 border-t border-white/5">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-3">Experienced Across</p>
          <ul className="space-y-2">
            {member.skills.map((skill) => (
              <li key={skill} className="flex items-center gap-2.5 text-sm text-slate-300">
                <Check className="w-4 h-4 text-[#00D4FF] shrink-0" />
                {skill}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </Reveal>
);

export const Team = () => (
  <section id="team" className="section bg-[#081C3A]" data-testid="team-section">
    <div className="container-custom">
      <SectionHeading
        eyebrow="Our People"
        title="Meet The Team Behind The Work"
        subtitle="Hands-on telecommunications specialists. At Quanticom our directors don't just manage — they're on the tools, in the field, delivering the work alongside our crews."
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {TEAM.map((m, i) => (
          <ProfileCard key={m.name} member={m} idx={i} />
        ))}
      </div>

      {/* Combined Capability */}
      <Reveal delay={0.1}>
        <div className="mt-12 rounded-2xl glass p-8 lg:p-12" data-testid="combined-capability">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="eyebrow mb-5">Combined Capability</span>
              <h3 className="text-2xl lg:text-3xl font-extrabold text-white mt-4 mb-4">
                Qualified, Accredited &amp; Experienced — Across The Board
              </h3>
              <p className="text-slate-300 leading-relaxed mb-4">
                Quanticom is a hands-on telecommunications contractor where company directors actively
                participate in field delivery. Our team is qualified, accredited and experienced across
                the full telecommunications infrastructure scope.
              </p>
              <div className="flex flex-wrap gap-4 mt-6">
                {[
                  { icon: BadgeCheck, label: "Fully Accredited" },
                  { icon: HardHat, label: "Hands-On Delivery" },
                  { icon: ShieldCheck, label: "Safety First" },
                ].map((b) => (
                  <span key={b.label} className="inline-flex items-center gap-2 text-sm font-semibold text-white">
                    <b.icon className="w-5 h-5 text-[#00D4FF]" /> {b.label}
                  </span>
                ))}
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-3">
              {COMBINED_CAPABILITY.map((cap, i) => (
                <div
                  key={cap}
                  className="flex items-center gap-3 rounded-xl card-dark p-4"
                  data-testid={`capability-discipline-${i}`}
                >
                  <span className="w-9 h-9 rounded-lg flex items-center justify-center bg-[#00D4FF]/10 border border-[#00D4FF]/25 shrink-0">
                    <Check className="w-5 h-5 text-[#00D4FF]" />
                  </span>
                  <span className="font-medium text-white text-sm">{cap}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
